import { FeatureExposureType } from '@/components/intro-wizards/types';
import {
  featureExposureControllerGetFeatureExposure,
  featureExposureControllerMarkFeatureExposureAsSeen,
} from '../api/generated/default/default';

export type FeatureExposureStep = number;

/**
 * Service to handle feature exposure tracking with the backend
 */
class FeatureExposureService {
  /**
   * Checks if a feature has been seen by the user
   * @param type The type of feature exposure to check
   * @returns Promise resolving to true if the feature has been seen, false otherwise
   */
  async hasFeatureBeenSeen(type: FeatureExposureType): Promise<boolean> {
    try {
      const response = await featureExposureControllerGetFeatureExposure(type);
      return !!response.dismissedAt;
    } catch (error) {
      console.error(`Error checking if feature ${type} has been seen:`, error);
      return false;
    }
  }

  /**
   * Marks a feature as seen by the user
   * @param type The type of feature exposure to mark as seen
   * @param completed Whether the feature exposure is completed (default: true)
   * @param step The step of the feature exposure (default: 0)
   * @returns Promise resolving to true if successful
   */
  async markFeatureAsSeen(
    type: FeatureExposureType,
    completed = true,
    step: FeatureExposureStep = 0
  ): Promise<boolean> {
    try {
      return await featureExposureControllerMarkFeatureExposureAsSeen({
        type,
        completed,
        step,
      });
    } catch (error) {
      console.error(`Error marking feature ${type} as seen:`, error);
      return false;
    }
  }
}

export default new FeatureExposureService();
